import { useMemo } from 'react';

import { useGetTagsBadges } from '@services/api/vaults/common.api';

import {
  BADGES_FILTERS_NAMES,
  BadgesType,
} from '@constants/common/badges.constants';

const useTagsBadges = (chains: number[]) => {
  const { data, isLoading } = useGetTagsBadges(chains);

  const badges = useMemo(
    () =>
      data
        ? data.badges.map(({ type }) => ({
            label: BADGES_FILTERS_NAMES[type as BadgesType],
            value: type,
          }))
        : [],
    [data],
  );

  return {
    badges,
    isLoading,
  };
};

export default useTagsBadges;
